import {PuiSpecificReferentielField} from "@portnet/ui";
import React from "react";

const AppSpecificReferentielField = React.forwardRef((props, ref) => {
  return <PuiSpecificReferentielField ref={ref} {...props} />;
});

export default AppSpecificReferentielField;
